import React, { useState } from "react";
import { Modal } from "react-bootstrap"
import PropTypes from "prop-types"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExchange } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";

const ModalAccountTransfer = (props) => {
    const [quotationId,setQuotationId] = useState(0)
    const [areaId,setAreaId] = useState(0)
    const transferAccountToArea = async () => {
        if ( quotationId <= 0 || areaId <= 0 )
        {
            alert("Debes seleccionar una cuenta y el area a transferir");
            return
        }
        try {
            // eslint-disable-next-line no-undef
            const resource = await axios.post(process.env.REACT_APP_PATH_API + 'transfer/account/to/area',
                {
                    token: localStorage.getItem('OSHEN-LOC-STR-TK'),
                    quotationId: quotationId,
                    areaId: areaId
                }),
                data = await resource.data;
                if(data.sessionOut){
                    // eslint-disable-next-line no-undef
                    location.href=process.env.REACT_APP_PATH_APP;
                    return;
                }
                props.getBusyTable()
                props.setVisible(false)
        } catch ( err ) {
            console.log('error en transferencia de cuenta', err)
        }
    }
    return (
        <Modal size="md" show={props.visible} onHide={()=>props.setVisible(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Transferencia de cuenta</Modal.Title>
            </Modal.Header>
            <Modal.Body>                
                <div className="row">
                    <div className="col-5">
                        <label>Cuenta</label>
                        <select className="form-control" onChange={(input)=>{
                            setQuotationId(Number(input.target.value))
                        }}>
                            <option value={0}>============</option>
                            {
                                props.accounts.map(({id}, idx)=>{
                                    let split = id.split(",")
                                    let splitArr = []
                                    for(let counter = 0;counter < split.length;counter++)
                                    {
                                        splitArr.push(<option key={`account-${idx}-counter-${counter}`} value={split[counter]}>#Cuenta.{split[counter]}</option>)
                                    }
                                    return splitArr
                                })                                
                            }
                        </select>
                    </div>
                    <div className="col-2" style={{textAlign: 'center'}}>
                        <FontAwesomeIcon icon={faExchange} style={{fontSize: 42, marginTop: 10}} />
                    </div>
                    <div className="col-5">
                        <label>Area</label>
                        <select className="form-control" onChange={(input)=>{
                            setAreaId(Number(input.target.value))
                        }}>
                            <option value={0}>============</option>
                            {
                                props.areas.map(({value, description}, idx)=>{
                                    return (<option key={`area-${idx}`} value={value}>{description}</option>)
                                })
                            }
                        </select>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-success" onClick={transferAccountToArea}>Transferir Cuenta</button>
            </Modal.Footer>
        </Modal>
    )
}

ModalAccountTransfer.propTypes = {
    accounts: PropTypes.array,
    areas: PropTypes.array,
    visible: PropTypes.bool,
    setVisible: PropTypes.func,
    getBusyTable: PropTypes.func
}

export default ModalAccountTransfer